import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { XCloseIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/base-components';
import Loader from '@rsos/components/capstone/Loader/Loader';
import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';
import { setAdrQueryStatus } from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCallsSlice';
import { useSelectedCall } from '@rsos/reduxDataStore/src/features/selectors/callQueueSelector';
import {
  CloseButton,
  RequestADRBanner,
  RequestADRButton,
} from './RequestAdr.styles';
import { deriveBannerState, getBannerStateUI } from './utils';

const trackButtonClick = () => {
  gspx.trackEvent({
    name: 'event_pane_adr_query_button_click',
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.EVENT_PANE,
    additionalKeys: {
      legacy_category: 'ADR',
      legacy_name: 'User clicks on ADR Query button',
      Category: 'ADR',
      'Launched date': new Date(),
    },
  });
};

const RequestAdr = () => {
  const dispatch = useDispatch();
  const selectedCall = useSelectedCall();
  const selectedCallerID = useSelector(
    state => state.emergencyCalls.selectedCallerID,
  );

  const adrQueryData = selectedCall?.adrQuery;
  const isFetched = adrQueryData?.fetched;
  const isLoading = adrQueryData?.loading;
  const hasData = adrQueryData?.hasData;
  const error = adrQueryData?.error;
  const hide = adrQueryData?.hide;

  const isSuccess = hasData && isFetched;

  const bannerState = deriveBannerState(error, isSuccess);

  const { bannerColor, bannerText, BannerIcon } = getBannerStateUI(
    bannerState,
    isLoading,
  );

  const handleClick = useCallback(() => {
    if (isLoading) return;
    dispatch(
      setAdrQueryStatus({
        callerID: selectedCallerID,
        loading: true,
        fetched: false,
      }),
    );
    trackButtonClick();
  }, [dispatch, selectedCallerID, isLoading]);

  const onClose = useCallback(() => {
    dispatch(
      setAdrQueryStatus({
        callerID: selectedCallerID,
        loading: false,
        fetched: true,
        hide: true,
      }),
    );
  }, [dispatch, selectedCallerID]);

  if (hide) return null;
  return (
    <RequestADRBanner horizontal bg={bannerColor}>
      <Box horizontal align="center" gridColumnGap="10px">
        {BannerIcon}
        <Text size="normal" color="background">
          {bannerText}
        </Text>
      </Box>

      {bannerState === 'success' ? (
        <CloseButton onClick={onClose}>
          <XCloseIcon color="background" />
        </CloseButton>
      ) : (
        <RequestADRButton noMargin onClick={handleClick}>
          {isLoading ? (
            <Loader noText />
          ) : (
            <Text color="secondaryText" size="normal">
              Request
            </Text>
          )}
        </RequestADRButton>
      )}
    </RequestADRBanner>
  );
};

export default RequestAdr;
